<template>
    <div class="outdiv">
      <div class="agreement">
        <header class="header van-hairline--bottom">
            <span>个人信息保护条款</span>
        </header>
        <div class="bodyAgreement">
            <p>1.广告页面内容、本条款及信息处理由云和提供并负责，与媒体平台无关。</p>
            <p>2.我方将按照本条款规定收集、处理您的个人信息。本协议可能涉及您个人信息权益的重要约定，请您在提供个人信息前仔细阅读。一旦您在页面上提交了相关信息，即视为您同意本协议的全部内容。</p>
            <p>3.为了解或满足您的需求以更好地实现本广告的推广目的，需要您按页面的表单提交相关信息，我方承诺将严格依照相关法律规定收集、处理您提交的信息。您有权拒绝提供上述信息，但可能无法获取进一步的广告信息。如您提供了上述信息，您应保证所有信息真实、准确、完整、有效。</p>
            <p>4.您同意我方可基于以下目的或原因自行或委托、安排第三方对您的个人信息进行收集和/或处理（这些第三方包括但不限于我们的经销商、广告服务合作方、客服服务商、数据分析服务商等）：</p>
            <p>（1）安排销售人员与您取得联系，满足您的需求；</p>
            <p>（2）向您提供更有价值的信息，实现广告推广目的； </p>
            <p>（3）用于广告投放与效果优化、广告归因与监测、商业分析与洞察等；</p>
            <p>（4）核验信息真实性；</p>
            <p>（5）其他法律法规许可的目的。</p>
            <p>5.我方将采取有效措施保障您的个人信息安全，同时会要求上述第三方按照不低于我方的安全标准保护您的个人信息。因我方及我方委托的第三方收集、处理您的个人信息产生的一切问题由我方负责。</p>
            <p>6.如您有任何投诉、建议或咨询，或有任何基于法律法规规定的权利请求，例如查询、修改、删除您的信息或撤回授权等，可通过邮件与我方联系。</p>
            <p>广告客户（信息收集方）：北京云和互动信息技术有限公司</p>
            <p>联系邮箱：lixia@yunheit.com</p>
        </div>
      </div>
      <div @click="cancelPopup" class="closebtn">
          <img src="~@/assets/images/closeImg.png" alt="" class="cancel"  style="width: 0.64rem;height: auto;">
      </div>
    </div>

</template>
<script>
export default {
  props:{
    name:{
      type: String,
      default:'XXX'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    cancelPopup () {
      this.$emit('cancelPopup', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.outdiv{
  position: relative;
  padding:0 10px;
  .agreement{
    background: #fff;
    padding-bottom: 10px;
    border-radius: 5px;
    .header {
        display: flex;
        align-items: center;;
        justify-content: center;
        padding:0 15px;
        height: 40px;
        span {
          line-height: 20px;
          text-align: center;
          font-size: 14px;
          color: #505050;
          margin: 0;
        }
    }
    .bodyAgreement{
      font-size: 12px;
      max-height: 310px;
      overflow-y: auto;
      padding: 20px;
      text-indent: 2em;
      line-height: 20px;
      -webkit-overflow-scrolling: touch;
      color: #505050;
    }
  }
  .closebtn{
   margin-top: 30px;
   display: flex;
   justify-content: center;
   align-items: center;
  }
}

</style>
